<template>
  <div id="cookie-banner" class="cookie-banner" :class="{'is-visible': !isAccepted}">
    Мы используем cookie. Оставаясь с нами, вы соглашаетесь на их применение <a href="/policy" target="_blank">Подробнее</a>
    <br>
    <button class="btn blue align-left" id="cookie-accept" @click="acceptCookies">OK</button>
  </div>
</template>

<script>

import { getCookie, setCookie } from '@/helpers/cookie';

export default {
  data() {
    return {
      isAccepted: false
    };
  },
  mounted() {
    // Чтение: возвращает true, если строка совпадает
    this.isAccepted = getCookie('accept-cookie') === 'true';
  },
  methods: {
    acceptCookies() {
      // Расчет даты истечения (например, через 365 дней)
      const expires = new Date(Date.now() + 365 * 24 * 60 * 60 * 1000);

      // Запись: передаем ключ, значение и опции
      setCookie('accept-cookie', 'true', { expires });
      
      this.isAccepted = true;
    }
  }
};
</script>

<style scoped>
.cookie-banner.is-visible {
  transform: translateY(0);
  opacity: 1;
  pointer-events: auto;
}
.cookie-banner {
  position: fixed;
  bottom: 20px;
  left: 20px;
  max-width: 320px;
  background: var(--background-color);
  opacity: 0;
  color: var(--textColor);
  padding: 14px 16px;
  font-size: 13px;
  line-height: 1.4;
  box-shadow: 0 2px 12px rgba(0, 0, 0, .25);
  border: 1px solid var(--textColor);
  border-radius: 8px;
  z-index: 2147483647;
  transform: translateY(20px);
  
  pointer-events: none;
  transition: transform .25s ease, opacity .25s ease;
  will-change: transform, opacity;
}
.cookie-banner a {
  color: var(--linkTextColor, #0c056d);
  text-decoration: underline;
}
/* html[data-theme="dark"] .cookie-banner button {
  color: #00222b;
} */
.cookie-banner button {
  display: inline-block;
  margin-top: 8px;
  margin-bottom: 0;
  color: #fff;
  border: none;
  border-radius: 6px;
  padding: 5px 14px;
  cursor: pointer;
  font-size: 13px;
}

@media only screen and (max-width: 800px) {
  .cookie-banner {
    max-width: calc(100% - 40px - 32px);
  }
}
</style>